module.exports = __webpack_public_path__ + "img/huawei.d051a416.png";